import { Modal, ModalHeader, ModalFooter, ModalBody, Button } from "reactstrap";
import { memo, useEffect, useState } from "react";

const ConfirmationModal = ({
    showModal,
    onClose,
    onCancelHandle,
    title = "Confirm",
    messagePrimary = "Do you really want to close this window?",
    messageSecondary = "Please click cancel to save changes before close",
    confirmLabel = "Close",
    cancelLabel = "Cancel"
}) => {
  
    const [modal, setModal] = useState(false)

    useEffect(() => {
        setModal(showModal)
    }, [showModal])

    const toggleModal = () => {
        setModal(!modal)
        onCancelHandle()
    }

    const onConfirmClick = () => {
        setModal(!modal)
        onClose()
    }

    return (
        <>
            <Modal isOpen={modal} toggle={toggleModal} backdrop={"static"} fade={false}>
                <ModalHeader style={{ backgroundColor: 'lightblue' }}>
                    {title}
                </ModalHeader>
                <ModalBody>
                    <h5>{messagePrimary}</h5>
                    {messageSecondary ? <h5>{messageSecondary}</h5> : null}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleModal}>
                        {cancelLabel}
                    </Button> {' '}
                    <Button color="danger" onClick={onConfirmClick}>
                        {confirmLabel}
                    </Button>
                </ModalFooter>
            </Modal>

        </>
    )
}

export default memo(ConfirmationModal)
